// import React, { FC, useEffect, useState } from "react";
// import { Row, Col } from "antd";
// import DispatchPanel from "./DispatchPanel/index";
// import MapPanel from "../../../containers/Dashboard/MapPanel/index";
// import { useDispatch, useSelector } from "react-redux";
// import { useHistory, useParams } from "react-router-dom";
// import Autocomplete from "react-google-autocomplete";
// import Geocode from "react-geocode";

// Geocode.setApiKey("AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY");
// Geocode.setLanguage("en");
// Geocode.setRegion("us");

// const Dashboard: FC<{ socket: ISocket }> = ({ socket }) => {
//   const history = useHistory();
//   const dispatch = useDispatch();
//   const [callingPageId, setCallingPageId] = useState<string | undefined>(
//     undefined
//   );
//   const [videoPlayerOpen, setVideoPlayerOpen] = useState<boolean>(false);
//   const [isCallNotificationDisplayed, setCallNotificaitonDisplayed] =
//     useState<boolean>(false);
//   const [screens, setScreens] = useState<any>({
//     form: true,
//     map: false,
//   });

//   const params: any = {
//     screens,
//     setScreens,
//   };

//   const fixedColSize = 24;

//   return (
//     <Row className="main-layout">
//       {screens.form && (
//         <Col
//           md={screens.map ? 12: fixedColSize}
//           xs={24}
//           className={screens.active === "form" ? "active-screen" : ""}
//         >
//           {screens.form && <DispatchPanel socket={socket} params={params} />}
//         </Col>
//       )}
//       {screens.map && (
//         <Col
//           md={12}
//           xs={24}
//           className={screens.active === "map" ? "active-screen" : ""}
//         >
//           <MapPanel socket={socket} params={params} />
//         </Col>
//       )}
//       <Autocomplete
//         apiKey="AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY"
//         style={{ display: "none" }}
//         options={{
//           types: ["(regions)"],
//           componentRestrictions: { country: ["us", "ca", "uk"] },
//         }}
//       />
//     </Row>
//   );
// };

// export default Dashboard;



import React, { FC, useEffect, useState } from "react";
import { Row, Col, Layout, Button } from "antd";
import DispatchPanel from "./DispatchPanel/index";
import MapPanel from "../../../containers/Dashboard/MapPanel/index";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import Autocomplete from "react-google-autocomplete";
import Geocode from "react-geocode";
import DashboardModal from "./Dashboard/DashboardModal";
import { generateUUID } from "utils/appUtil";

Geocode.setApiKey("AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY");
Geocode.setLanguage("en");
Geocode.setRegion("us");

const Dashboard: FC<{ socket: ISocket }> = ({ socket }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [screens, setScreens] = useState<any>({
    form: true,
    map: true,
  });
  const [selected, setSelected] = useState<string>("map");
  const [componentUuids, setComponentUuid] = useState<any>({
    driver: generateUUID(),
    advance: generateUUID(),
    dispatch: generateUUID(),
    all: generateUUID(),
  });
  const params: any = {
    screens,
    setScreens,
  };
  const fixedColSize = 24;

  return (
    <Row
      className="main-layout"
      style={{
        transform: "scale(0.8)",
        transformOrigin: "0 0",
        width: "125vw",
        height: "100vh",
      }}
    >
      {screens.form && (
        <Col
          md={screens.map ? 7 : fixedColSize}
          xs={24}
          className={screens.active === "form" ? "active-screen" : ""}
          style={{
            height: "calc((100vh / 0.8) - 50px)",
            overflow: "scroll",
          }}
        >
          {screens.form && (
            <DispatchPanel
              socket={socket}
              params={params}
            />
          )}
        </Col>
      )}
      {screens.map && (
        <Col
          span={17}
          style={{
            height: "calc((100vh / 0.8) - 50px)",
            overflow: "scroll",
          }}
        >
          <Row>
            <Col
              span={24}
              className={`ride-container nine-container ${
                screens.active === "map" ? "active-screen" : ""
              }`}
            >

              {selected === "map" && (
                <MapPanel socket={socket} params={params} />
              )}

            </Col>
            <Col span={24}>
              <div className="beam-modal analytics-summary-modal mr-4">
                <Layout
                  className="main-layout exec-layout mt-3"
                  style={{ padding: 0 }}
                >
                  <DashboardModal
                    socket={socket}
                    filter={true}
                    componentUuid={componentUuids.all}
                  />
                </Layout>
              </div>
            </Col>
          </Row>
        </Col>
      )}
      <Autocomplete
        apiKey="AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY"
        style={{ display: "none" }}
        options={{
          types: ["(regions)"],
          componentRestrictions: { country: ["us", "ca", "uk"] },
        }}
      />
    </Row>
  );
};

export default Dashboard;


